export interface Domain {
  d_id: number;
  domain: string;
}

export interface CompanyOwnershipInterface {
  ot_full: string;
  ot_id: number;
  ot_short: string;
}

export interface Company {
  new_name?: string;
  ps_id: number;
  partnership_id: number;
  ps_name: string;
  ps_contract: string;
  ps_legal_address: string;
  la_country: string;
  la_region_name: string;
  la_city_type: string;
  la_city_name: string;
  la_street_type: number;
  la_street_name: string;
  la_house_number: string;
  la_house_building: string;
  la_office_number: string;
  ps_physical_address: string;
  pa_country: string;
  pa_region_name: string;
  pa_city_type: string;
  pa_city_name: string;
  pa_street_type: number;
  pa_street_name: string;
  pa_house_number: string;
  pa_house_building: string;
  pa_office_number: string;
  rec_create_date: string;
  rec_actual_date: string | null;
  version_number: string;
  created_by: number;
  is_visible: number;
  ownership_type: CompanyOwnershipInterface;
  legal_postcode: string;
  physical_postcode: string;
  domains: Domain[];
  created_by_user: string;
  updated_by_user: string;
  create_date: string;
  update_date: string;
  effective_date: string | null;
  expiration_date: string | null;
}

export interface Companies {
  count: number;
  next: any;
  previous: any;
  results: Company[];
}

export interface CompanyNames {
  campaign_id: number;
  is_visible: number;
  ownership_type: CompanyOwnershipInterface;
  ps_name: string;
  new_name?: string;
}

export interface CompanyCodesNames {
  partner_code: string;
  is_without_code?: boolean;
}

export interface StreetType {
  st_id: number;
  st_short: string;
  st_type: string;
}

export const COMPANIES_PATHS = {
  companies: 'companies',
  companies_create: 'companies/create',
  companies_edit: 'companies/:campaign_id',
};
